import { render } from "./RegionLocations.vue?vue&type=template&id=496e31f2"
import script from "./RegionLocations.vue?vue&type=script&lang=js"
export * from "./RegionLocations.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__